<template>
  <div>
    <div class="text-center mt-6" v-if="!dataLoaded">
      <v-progress-circular :size="50" color="primary" indeterminate />
    </div>

    <div v-show="dataLoaded">
      <v-row class="my-0">
        <v-col cols="12" class="py-0">
          <v-card class="table-card">
            <v-data-table
              :loading="tableLoading"
              ref="academicWorksTable"
              class="base-table"
              fixed-header
              hide-default-footer
              :headers="headers"
              :items="academicWorks"
              :items-per-page="-1"
            >
              <template #item.isRelevant="{ item }">
                <div class="d-flex justify-center">
                  <v-checkbox
                    v-model="item.isRelevant"
                    class="is-relevant"
                    hide-details
                    :ripple="false"
                    @change="updateAcademicWorks"
                  />
                </div>
              </template>

              <template slot="no-data">
                <div>Таблица пуста</div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { catalogApi } from '@/api'
import { mapGetters } from 'vuex'
import { AcademicWork } from '@/models'

export default {
  name: 'AcademicWorks',

  metaInfo: {
    title: 'Типы занятий'
  },

  async created() {
    await this.getAcademicWorks()
    this.dataLoaded = true
  },

  mounted() {
    this.hideHtmlOverflow()
    this.setTableHeight()
    window.addEventListener("resize", this.setTableHeight)
  },

  destroyed() {
    this.showHtmlOverflow()
    window.removeEventListener("resize", this.setTableHeight)
  },

  data: () => ({
    dataLoaded: false,
    tableLoading: false,
    headers: [
      { text: 'Тип занятия', value: 'name', sortable: false, align: 'left' },
      { text: 'Блок', value: 'academicWorkTypeId.name', sortable: false, align: 'left', width: '150px' },
      { text: 'Учитывать в педнагрузке ДПО', value: 'isRelevant', sortable: false, align: 'left', width: '210px' }
    ],

    academicWorks: []
  }),

  computed: {
    ...mapGetters('system', ['techMessageHeight'])
  },

  methods: {
    async getAcademicWorks() {
      try {
        const data = await catalogApi.getAcademicWorksForSettings()
        this.academicWorks = data.map(el => AcademicWork.buildFromAPI(el))
      } catch (e) {
        console.log(e.status)
      }
    },

    async updateAcademicWorks() {
      try {
        this.tableLoading = true

        await catalogApi.updateAcademicWorksForSettings(this.academicWorks)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.tableLoading = false
      }
    },

    setTableHeight() {
      // суммарная высота элементов на странице, кроме таблицы
      const otherElements = 277 + this.techMessageHeight

      if (this.$refs?.academicWorksTable) {
        this.$refs.academicWorksTable.$el.style.maxHeight = window.innerHeight - otherElements + 'px'
      }
    },

    hideHtmlOverflow() {
      document.querySelector('html').style.setProperty('overflow-y', 'hidden', 'important')
    },

    showHtmlOverflow() {
      document.querySelector('html').style.overflowY = 'visible'
    }
  }
}
</script>

<style scoped>
.is-relevant {
  margin: 0 0 0 -2px;
  padding-top: 0;
}
</style>